<template>
  <b-container class="container">
    <b-collapse v-model="btn_toggle">
      <b-button
        v-if="this.$parent.event.stages.length > 0"
        size="sm"
        @click="addsession"
        variant="primary"
      >
        Create New Session
      </b-button>
    </b-collapse>

    <div v-if="addsession_toggle">
      <b-row class="mt-1">
        <b-col>
          <label>Session Name</label>
          <b-form-input v-model="edit.title" maxlength="150"></b-form-input>
          <b-collapse v-model="title_error">
            <label class="error">Title is required</label>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row class="mt-1" align-v="center">
        <b-col cols="4">
          Start&nbsp
          <date-picker
            placeholder="Start time"
            v-model="start_date"
            type="datetime"
            :clearable="false"
            :not-before="new Date($parent.event.startep)"
            :not-after="new Date($parent.event.endep)"
            lang="en"
            format="MM-DD-YYYY [at] hh:mm A"
            :time-picker-options="{
              start: '00:00',
              step: '00:15',
              end: '23:59',
            }"
          ></date-picker>
        </b-col>
        <b-col cols="4">
          End&nbsp
          <date-picker
            placeholder="End time"
            v-model="end_date"
            type="datetime"
            :clearable="false"
            :not-before="start_date"
            :not-after="new Date($parent.event.endep)"
            :input-attr="{ required: true }"
            lang="en"
            format="MM-DD-YYYY [at] hh:mm A"
            :time-picker-options="{
              start: '00:00',
              step: '00:15',
              end: '23:59',
            }"
          ></date-picker>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col>
          <label>Description (optional)</label>
          <b-form-textarea
            v-model="edit.description"
            rows="3"
            max-rows="6"
            maxlength="600"
          ></b-form-textarea>
          <b-collapse v-model="description_error">
            <label class="error">Description is required</label>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b> Session Banner (optional) </b>
          <upload-image
            v-model="edit.banner"
            :evid="$parent.event.id"
            :imgkind="'session' + edit.id + '-banner'"
            optional="true"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b> Sponsors</b>
          <b-form-group label="" label-for="tags-with-dropdown">
            <b-form-tags
              id="tags-with-dropdown"
              v-model="edit.session_sponsors"
              no-outer-focus
              class="mb-2"
            >
              <template v-slot="{ tags, disabled, addTag, removeTag }">
                <ul
                  v-if="tags.length > 0"
                  class="list-inline d-inline-block mb-2"
                >
                  <li v-for="tag in tags" :key="tag" class="list-inline-item">
                    <b-form-tag
                      @remove="
                        removeTag(tag);
                        removeSponsor(tag);
                      "
                      :title="tag"
                      :disabled="disabled"
                      variant="info"
                      >{{ tag }}</b-form-tag
                    >
                  </li>
                </ul>

                <b-dropdown
                  size="sm"
                  variant="outline-secondary"
                  block
                  menu-class="w-100"
                >
                  <template #button-content>
                    <b-icon icon="tag-fill"></b-icon> Choose Sponsors
                  </template>
                  <b-dropdown-form @submit.stop.prevent="() => {}">
                    <b-form-group
                      label="Search Sponsors"
                      label-for="tag-search-input"
                      label-cols-md="auto"
                      class="mb-0"
                      label-size="sm"
                      :description="searchDesc"
                      :disabled="disabled"
                    >
                      <b-form-input
                        v-model="search"
                        id="tag-search-input"
                        type="search"
                        size="sm"
                        autocomplete="off"
                      ></b-form-input>
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                    v-for="option in availableOptions"
                    :key="option.id"
                    @click="onOptionClick({ option, addTag })"
                  >
                    {{ option.name }}
                  </b-dropdown-item-button>
                  <b-dropdown-text v-if="availableOptions.length === 0">
                    There are no sponsors available to select
                  </b-dropdown-text>
                </b-dropdown>
              </template>
            </b-form-tags>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="this.$parent.event.stages.length > 0">
        <b-col>
          <label>Select a stage for the session</label>
        </b-col>
        <b-col>
          <b-form-select v-model="selectedstage">
            <b-form-select-option
              v-for="stage in this.$parent.event.stages"
              :value="stage"
              >{{ to_disp_name(stage.name) }}</b-form-select-option
            >
          </b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="this.$parent.event.networking.length > 0">
        <b-col>
          <label>Or Select a networking room </label>
        </b-col>
        <b-col>
          <b-form-select v-model="selectedstage">
            <b-form-select-option
              v-for="nw in this.$parent.event.networking"
              :value="nw"
              >{{ to_disp_name(nw.title) }}</b-form-select-option
            >
          </b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-collapse v-model="stage_error">
          <label class="error">Stage/Networking room has to be selected</label>
        </b-collapse>
      </b-row>

      <b-collapse v-model="speakerbtn">
        <b-button variant="primary" size="sm" @click="show_speaker_form">
          Create New Speaker
        </b-button>
      </b-collapse>
      <b-collapse v-model="speaker_form">
        <b-row class="speakerrow">
          <b-col>
            <label>Speaker Name</label>
          </b-col>
          <b-col>
            <b-form-input v-model="editspeaker.name"></b-form-input>
            <b-collapse v-model="speakername_error">
              <label class="error">A name has to be provided</label>
            </b-collapse>
          </b-col>
        </b-row>
        <b-row class="speakerrow">
          <b-col>
            <label>Speaker's Email</label>
          </b-col>
          <b-col>
            <b-form-input v-model="editspeaker.email"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="speakerrow">
          <b-col>
            <b-collapse v-model="speakeremail_error">
              <label class="error">An email has to be provided</label>
            </b-collapse>
          </b-col>
        </b-row>
        <b-row class="speakerrow">
          <b-col>
            <label>Speaker Description (Optional)</label>
          </b-col>
          <b-col>
            <b-form-textarea v-model="editspeaker.descr"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="speakerrow">
          <b-col>
            <label>Speaker's Picture (optional)</label>
          </b-col>
        </b-row>
        <b-row class="speakerrow">
          <b-col>
            <upload-image
              v-model="editspeaker.pic"
              :evid="$parent.event.id"
              :imgkind="'speaker' + editspeaker.id + '-pic'"
            />
          </b-col>
        </b-row>
        <b-row class="speakerrow">
          <b-col>
            <label>Speaker Bio link (optional)</label>
          </b-col>
          <b-col>
            <b-form-input v-model="editspeaker.bio"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="speakerrow">
          <b-col>
            <center>
              <b-button variant="primary" size="sm" @click="add_speaker">
                Add
              </b-button>
              <b-button
                variant="outline-danger"
                size="sm"
                @click="hide_speaker_form"
              >
                Cancel
              </b-button>
            </center>
          </b-col>
        </b-row>
      </b-collapse>

      <b-row>
        <b-col sm="2"> </b-col>
        <b-col>
          <div align-v="center" v-for="(speaker, index) in this.speakers">
            Speaker: {{ speaker.name }}
            &nbsp;
            <b-button @click="edit_speaker(index)" size="sm" variant="primary">
              Edit
            </b-button>
            <b-button @click="delete_speaker(index)" size="sm" variant="danger">
              Delete
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            :disabled="isSubmitDisabled || speaker_form"
            size="sm"
            v-on:click="update"
            variant="primary"
          >
            Submit
          </b-button>
          <b-button
            :disabled="speaker_form"
            size="sm"
            v-on:click="cancelsession"
            variant="outline-danger"
          >
            Cancel
          </b-button>
          <confirm-del class="float-right" variant="danger"
             v-on:confirmed-delete="deletesession()">
          </confirm-del>

          <b-collapse v-model="event_success">
            <label class="message">Session has been added</label>
          </b-collapse>
          <b-collapse v-model="event_failure">
            <label class="error"
              >Session couldn't be created due to an error</label
            >
          </b-collapse>
        </b-col>
      </b-row>
    </div>

    <label
      v-if="
        this.$parent.event.stages.length == 0 && addsession_toggle == false
      "
      ><b
        >No stages in this event. Please make sure at least one stage is
        created to add sessions.</b
      ></label
    >

    <div v-if="!addsession_toggle">
      <b-card-group deck>
        <b-card
          v-for="(session, index) in this.$parent.event.sessions"
          :title="session.title"
          class="upsession_card"
          :img-src="session.banner"
          img-width="150"
          img-height="200"
        >
          <label
            ><b>{{ room_dname($parent.event, session.roomname) }}</b></label
          ><br />
          <label
            ><b>{{ datestring(session) }}</b></label
          >
          <div v-for="speaker in session.speakers">
            <b
              >Speaker:&nbsp;<img
                v-if="speaker.pic"
                :src="speaker.pic"
                class="speakerimg"
              />&nbsp; &nbsp;{{ speaker.name }}</b
            >&nbsp;
            <b-link v-if="speaker.bio" @click="openbio(speaker.bio)"
              >(Bio)</b-link
            ><br />
            Email:&nbsp;{{ speaker.email }}<br />
          </div>
          <br />
          <b-card-text v-if="session.description" class="para"
            >{{ session.description }}
          </b-card-text>

          <b-button variant="primary" size="sm" @click="editsession(index)">
            Edit Session
          </b-button>
         
        </b-card>
      </b-card-group>
    </div>

  </b-container>
</template>

<script>
import { sync } from "vuex-pathify";
import DatePicker from "vue2-datepicker";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import UploadImage from "../components/UploadImage";
import ConfirmDel from "../components/ConfirmDel";

export default {
  name: "update_sessions",
  data() {
    return {
      search: "",
      computeupdate: 0, // update available options
      edit: {
        title: "",
        description: "",
        banner:
          "https://images.freeimages.com/images/large-previews/1ce/stars-1194599.jpg",
      },
      editspeaker: {
        name: "",
        descr: "",
        pic: "",
        bio: "",
        email: "",
      },
      currentsession: -1,
      btn_toggle: true,
      addsession_toggle: false,
      start_date: new Date(),
      end_date: new Date(),
      title_error: false,
      description_error: false,
      file_error: false,
      stage_error: false,
      selectedstage: "",
      room_error: false,
      group_error: false,
      speakerbtn: true,
      speaker_form: false,
      speakername_error: false,
      speakeremail_error: false,
      speakers: [],
      curspeaker: 0,
      event_success: false,
      event_failure: false,
      isSubmitDisabled: false,
    };
  },
  components: {
    DatePicker,
    UploadImage,
    ConfirmDel,
  },
  created() {},
  computed: {
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      this.computeupdate;
      // Filter out already selected options
      const options = this.$parent.event.sponsors.filter(
        (opt) =>
          this.edit.session_sponsors || [].indexOf(opt.name) === -1
      );

      if (criteria) {
        // Show only options that match criteria
        return this.$parent.event.sponsors.filter(
          (opt) => opt.name.toLowerCase().indexOf(criteria) > -1
        );
      }
      // Show all options available
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return "There are no sponsors matching your search criteria";
      }
      return "";
    },
  },
  methods: {
    onOptionClick({ option, addTag }) {
      addTag(option.name);
      this.search = "";
      this.computeupdate++;
      console.log("edit sesions", this.edit.session_sponsors);
    },
    removeSponsor(option) {
      console.log("edit sesions", this.edit.session_sponsors);
      console.log("Option", option);
      this.computeupdate++;
    },
    getBannerName: utils.getBannerName,
    datestring: utils.datestring,
    openbio: utils.openbio,
    formatter(value) {
      return (value = 0) ? "00" : value;
    },
    trimroom: function (roomname) {
      var parts = roomname.split("/");
      if (parts.length == 2) {
        return parts[1];
      } else {
        return "";
      }
    },
    show_speaker_form: function () {
      if (!this.selectedstage) {
        this.stage_error = true;
        return;
      }
      this.speaker_form = true;
      this.speakerbtn = false;

      this.curspeaker = this.speakers.length;
      this.editspeaker = {
        name: "",
        descr: "",
        pic: "https://images.freeimages.com/images/large-previews/965/mic-1144239.jpg",
        bio: "",
        email: "",
      };
      this.editspeaker.id = utils.new_id(this.$parent.event);
      this.editspeaker.sessionid = this.edit.id;
    },
    edit_speaker: function (index) {
      this.speaker_form = true;
      this.speakerbtn = false;

      this.curspeaker = index;
      let sp = this.speakers[index];
      this.editspeaker.sessionid = this.edit.id;
      this.editspeaker.id = sp.id;
      this.editspeaker.name = sp.name;
      this.editspeaker.descr = sp.descr;
      this.editspeaker.pic = sp.pic;
      this.editspeaker.bio = sp.bio;
      this.editspeaker.email = sp.email;
    },
    hide_speaker_form: function () {
      this.speaker_form = false;
      this.speakerbtn = true;
    },
    add_speaker: function () {
        if (!this.editspeaker.name) {
                this.speakername_error = true;
                return;
        }
        this.speakername_error = false;
        
        if (!this.editspeaker.email) {
                this.speakeremail_error = true;
                return;
        }
        this.speakeremail_error = false;
        this.speakername_error = false;

        this.speakers[this.curspeaker] = this.editspeaker;

        this.speaker_form = false;
        this.speakerbtn = true;
        this.isUploadDisabled = false;
    },
    delete_speaker(index) {
        let sp = this.speakers[index];
        if (sp.email) {
            window.wss_send(vx, "adm_event_add_attendee", {
             rtag:"session",
             event: {
               id: this.$parent.event.id,
             },
             att: {
               em: sp.email,
               access: [{
                 id: this.edit.id+"-"+sp.id,
                 rem: true,
               }]
             }
           });
        }
        this.speakers.splice(index,1);
    },
    room_dname: utils.room_dname,
    to_disp_name: function(roomname) {
        if (!roomname) return "";
        var idx = roomname.indexOf("-");
        var subs = roomname.substring(idx+1);
        return subs.replaceAll("-"," ");
    },
    addsession: function () {
      this.title_error = false;
      this.description_error = false;
      this.stage_error = false;

      this.addsession_toggle = true;
      this.btn_toggle = false;
      this.isSubmitDisabled = false;

      this.currentsession = this.$parent.event.sessions.length;
      this.edit = {
        title: "",
        description: "",
        banner:
          "https://images.freeimages.com/images/large-previews/1ce/stars-1194599.jpg",
      };
      this.edit.id = utils.new_id(this.$parent.event);
      this.speakers = [];
      this.start_date = new Date(this.$parent.event.startep);
      this.end_date = new Date(this.$parent.event.endep);
    },
    cancelsession: function () {
      let vue = this;
      vue.currentsession = -1;
      vue.addsession_toggle = false;
      vue.btn_toggle = true;
      vue.$parent.notify({
         action:"SESSION_EDIT_DONE",
         sessionid: vue.edit.id,
      });
      vue.edit.id = null;
    },
    deletesession: function () {
      let vue = this;
      vue.currentsession = -1;
      /* Only need to send what changed */
      let event = {sessions:[],delta:true};
      event.id = this.$parent.event.id;
      this.edit.rem = true;
      utils.session_modified(this.$parent.event, this.edit);
      event.sessions.push(this.edit);
      window.wss_send(vx, "adm_event_set", {rtag:"session",
         event: event
      });
      delete vue.edit.rem;

      vue.edit.speakers = vue.edit.speakers || [];
      vue.edit.speakers.forEach(function(sp) {
         if (!sp.email) { return; }
         window.wss_send(vx, "adm_event_add_attendee", {
           rtag:"session",
           event: {
             id: vue.$parent.event.id,
           },
           att: {
             em: sp.email,
             access: [{
               id: vue.edit.id+"-"+sp.id,
               rem: true,
             }]
          }
        });
      }); // speakers
    },
    editsession: function(index) {
        let vue = this;

        this.title_error = false;
        this.description_error = false;
        this.stage_error = false;
        this.currentsession = index;

        var sess = this.$parent.event.sessions[this.currentsession];

        this.edit = {};
        this.edit.id = this.$parent.event.sessions[this.currentsession].id;
        this.edit.ver = this.$parent.event.sessions[this.currentsession].ver;
        this.edit.pver = this.$parent.event.sessions[this.currentsession].pver;
        this.edit.title = this.$parent.event.sessions[this.currentsession].title;
        this.edit.description = this.$parent.event.sessions[this.currentsession].description;
        this.edit.banner = this.$parent.event.sessions[this.currentsession].banner;
        this.edit.roomname = this.$parent.event.sessions[this.currentsession].roomname;
        this.edit.session_sponsors =
          this.$parent.event.sessions[this.currentsession].session_sponsors;

        this.$parent.event.stages.forEach(function(st) {
                if (st.roomname == sess.roomname) {
                        vue.selectedstage = st;
                }
        });
        this.$parent.event.networking.forEach(function(nw) {
                if (nw.roomname == sess.roomname) {
                        vue.selectedstage = nw;
                }
        });
        this.speakers = this.$parent.event.sessions[this.currentsession].speakers;
        this.start_date =
          new Date(this.$parent.event.sessions[this.currentsession].startep);
        this.end_date =
          new Date(this.$parent.event.sessions[this.currentsession].endep);
        this.addsession_toggle = true; 
        this.btn_toggle = false;
        this.isSubmitDisabled = false;

        this.$parent.notify({
          // em, full_admin, code are filled in by the server
          action:"SESSION_EDIT_START",
          sessionid: vue.edit.id,
        });
    },
    update: function() {
        let ev = this.$parent.event;
        let vue = this;
        vue.file_error = false;
        vue.group_error = false;
        if (!vue.edit.title) {
          vue.title_error = true;
          return;
        }

        var startep = vue.start_date.getTime();
        var endep = vue.end_date.getTime();
        if (!startep) {
           vue.$parent.toast("err","Session start time required");
           return;
        }
        if (startep < ev.startep) {
           vue.$parent.toast("err","Session start time before event");
           return;
        }
        if (!endep) {
           vue.$parent.toast("err","Session end time requried");
           return;
        }        
        if (endep > ev.endep) {
           vue.$parent.toast("err","Session end time after event");
           return;
        }

        if (vue.selectedstage == '') {
           vue.stage_error = true;
           return;
        }
        vue.stage_error = false;

        vue.edit.kind = 'session';
        vue.edit.startep = startep;
        vue.edit.endep = endep;
        vue.speakers.forEach(function(sp) {
          if (!sp.email) { return; }
          window.wss_send(vx, "adm_event_add_attendee", {
            rtag:"session",
            event: {
              id: vue.$parent.event.id,
            },
            att: {
              em: sp.email,
              name: sp.name,
              access: [{
                   id: vue.edit.id+"-"+sp.id,
                   roomname:vue.selectedstage.roomname,
                   startep: vue.edit.startep,
                   endep: vue.edit.endep,
                   is_pan: true,
              }]
            }
          });
        });

        vue.edit.roomname = vue.selectedstage.roomname;
        vue.edit.speakers = vue.speakers;
        utils.session_modified(ev,vue.edit);

        vue.isSubmitDisabled = true;
        /* Only need to send what changed */
        let event = {sessions:[],delta:true};
        event.id = ev.id;
        event.sessions.push(vue.edit);
        window.wss_send(vx, "adm_event_set", {rtag:"session",
            event: event
        });
     },

    upload_speakerpic: function () {
      console.log("Uploading speakerpic...");
      if (!this.speakerFile) {
        this.pic_file_error = true;
        return;
      } else {
        this.pic_file_error = false;
      }
      let vue = this;
      let ev = this.$parent.event;
      let mime = this.speakerFile.type;
      if (!mime || !mime.match("image")) {
        this.pic_file_error = true;
        return;
      }
      let reader = new FileReader();
      reader.onload = function (e) {
        let img = e.target.result;
        vx_api
          .createObj(window.vx, { evid: ev.id, evpart: vue.speakerFile.name })
          .then((stream) => {
            if (stream && stream.upload && stream.upload.url) {
              let url = stream.upload.url;
              api_put_awsfile(
                url,
                { content_type: mime, payload: img },
                function (status, data) {
                  console.log(status);
                  console.log("Uploaded to " + url.split("?")[0]);
                  vue.speakerpic = url.split("?")[0];
                  vue.pic_upload_pending = false;
                  vue.pic_upload_success = true;
                }
              );
            }
          });
      };
      reader.onerror = function (e) {
        // eslint-disable-next-line
        console.log("file error");
        vue.pic_upload_error = true;
      };
      reader.readAsArrayBuffer(vue.speakerFile);
    },
    setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
      //vue.start_date = new Date(vue.$parent.event.startep);
      //vue.end_date = new Date(vue.$parent.event.endep);
    },
  },
  watch: {
    "$parent.event.id": function (to, from) {
      this.setup();
    },
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx, "update_sessions");
  },
  mounted() {
    let vue = this;
    vue.event_success = false;
    vue.setup();
    window.wss_open(vx, {
      acc: vue.$parent.acc,
      uid: vx.user.id,
      routes_id: "update_sessions",
      routes: {
        adm_room_list: function(msg) {
           vue.rooms = msg.data.r;
        },
        adm_event_set: function(msg) {
           if (msg.rtag != "session") return;
           vue.isSubmitDisabled = false;

           if (msg.data.error) {
             vue.$parent.toast("err","event_set error "+msg.data.error);
             console.warn(msg.data.error);
             return;
           }
           if (msg.data.event) {
             vue.$parent.event = utils.remote_to_local(msg.data.event);
           } else if (vue.currentsession >= 0) {
             vue.$parent.event.sessions[vue.currentsession] = vue.edit;
           }

           vue.addsession_toggle = false;
           vue.btn_toggle = true;
           vue.isSubmitDisabled = false;
           vue.isUploadDisabled = false;

           vue.$parent.notify({
              action:"SESSION_EDIT_DONE",
              sessionid: vue.edit.id,
           });
           vue.edit.id = null;
           vue.currentsession = -1;
        },
        evnotify: function(msg) {
          if (!msg || !msg.data | !msg.data.sessionid) { return; }
          if (!vue.edit || !vue.edit.id) {
             /* Not currently editing a session */
          } if (vue.edit.id != msg.data.sessionid) {
             /* Editing a different session */
          } else {
             /* Editing the same session */
             if (msg.data.action == "SESSION_EDIT_DONE") {
               vue.$parent.toast("ok", msg.data.em+" stopped editing this session.");
             } else if (msg.data.action == "SESSION_EDIT_START") {
               vue.$parent.toast("err", msg.data.em+" started editing this session.");
               vue.$parent.notify({
                 action:"SESSION_EDIT_INPROGRESS",
                 sessionid: vue.edit.id,
               });
             } else if (msg.data.action == "SESSION_EDIT_INPROGRESS") {
               vue.$parent.showconfirm("danger", msg.data.em+" is  currently editing this session. Are you sure you want to make a change?",
                 null,
                 function() {
                    vue.cancelsession();
                 }
               );
             }
          }
        },
        adm_event_add_attendee: function(msg) {
           if (msg.rtag != "session") return;
           if (msg.data.error) {
              console.log(msg.data.error);
           }
        },
      }
    });
  },
};
</script> 
<style lang="scss" scoped>
.container {
  max-width: 960px;
}
.upsession_card {
  min-width: 20rem;
  max-width: 30rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
.speakerrow {
  margin-top: 0;
  background-color: #d3d3d3;
}
.error {
  color: red;
  padding-top: 10px;
  font-weight: 500;
}
.message {
  font-weight: 500;
  color: red;
  padding-top: 5px;
}
.para {
  margin-top: 10px;
  white-space: pre-wrap;
}
.speakerimg {
  border-radius: 50%;
  width: 80px;
  height: 80px;
}
</style>
